<template>
  <div>
    <input
        class="chat-widget__footer-attach"
        type="file"
        ref="fileInput"
        @change="handleFileSelect"
        :multiple="multiple"
        :accept="accept"
        style="display: none"
    />
    <Button
        icon="pi pi-paperclip"
        class="chat-widget__footer-attach"
        outlined
        v-tooltip.bottom="'Прикрепить файлы'"
        @click="triggerFileInput"
    />
  </div>
</template>
<script setup>
import Button from 'primevue/button';
import { ref } from 'vue';

const emit = defineEmits(['add-files']);
const fileInput = ref(null);
const triggerFileInput = () => {
  fileInput.value.click();
};
defineProps({
  multiple: {
    type: Boolean,
    required: true
  },
  accept: {
    type: String,
    default: '*/*' // По умолчанию принимаем все типы файлов
  }
});
const handleFileSelect = (event) => {
  const newFiles = Array.from(event.target.files);
  emit('add-files', newFiles);
  event.target.value = '';
};
</script>